import Util from '../../../Common/Util';
/**
 * ListRender — 사용자PC(/u/orders) 엑셀형 오더 테이블의 목록 렌더링.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 렌더 클러스터 16함수를 이 모듈로 이관했다:
 *   get_orders / refresh_orders / render_order_all / get_order_line_html /
 *   show_payStatus / Soojoo_billinfo / bill_print_statusGet / show_DataList /
 *   showOrderInfo / hideSooHPinfo / show_car_no / getString / pad / show_carnum_plate /
 *   get_order_payed_type / get_order_payed_class
 *
 * 구조 방식 (다른 모듈과 다름 — 규모 때문)
 * ─────────────────────────────────────────
 * 700줄 규모라 클래스 메서드로 재작성하지 않고 "모듈 스코프 자유함수"로 거의 원문 유지한다.
 *   - 함수끼리의 내부 호출(getString/show_payStatus 등)은 모듈 스코프에서 그대로 해소된다.
 *   - 외부 전역(int/number_format/orderTax/$j/order_status_aryadmin/mkList/bonsaList/
 *     getParentSosokCode/get_order_fee_rate/render_template/apply_filter/doc_Scroll)은 읽기/호출이라
 *     strict 모듈에서도 스코프체인으로 전역에 해소된다 → bare 유지.
 *   - onclick 문자열 안의 함수(allSetIn_new/show_Pop_BizForm/showClickedOrder/showOrderInfo/
 *     order_clearSet)는 클릭시 window 전역으로 해소된다 → 문자열 그대로.
 *   - strict 위반이 되는 "미선언 변수 할당"만 수정: 지역 temp 는 var 선언, 공유 blade 전역
 *     쓰기(showPriceTotal/boxOn_showCnt/total_order_count/onList)는 window.* 로.
 *
 * 진입점은 $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지한다:
 *   - window.render_order_all       : SearchFilter(서버조회 후 렌더) + __ordersPageBoot
 *   - window.get_orders             : ExpensePanel/저장 등 부분갱신 + list.js 잔류 함수
 *   - window.get_order_payed_type   : SearchFilter(완료제외 필터)
 *   - window.showOrderInfo          : get_order_line_html 이 만든 수주자명 onclick
 *   - window.hideSooHPinfo          : showOrderInfo 팝업 onclick
 */

// ── get_orders : 특정 오더들만 새로가져와 갱신 ──
function get_orders(ordernum_list) {
    if (!ordernum_list) {
        if (!orderTax.current_ordernum) return;
        ordernum_list = [orderTax.current_ordernum];
    }

    var adr = "/u/ajax/order/list";
    $.ajax({
        type: "get",
        url: adr,
        data: { 'ordernum_list': ordernum_list.join(',') },
        dataType: 'json',
        success: function (order_list) {
            orderTax.update_orders(order_list);
            refresh_orders(ordernum_list);
        }
    });
}

// ── refresh_orders : 지정 오더들 목록화면 갱신 ──
function refresh_orders(ordernum_list) {
    ordernum_list.forEach((ordernum) => {
        var order_info = orderTax.find_order(ordernum);
        // TD 영역 html 새로 만들기
        let tds = get_order_line_html(order_info, 0);
        // TR 찾기
        let trid = "tr_order_" + ordernum;
        var clss = get_order_payed_class(order_info);
        $('#' + trid).html(tds).attr('class', clss);
    });
}

// ── render_order_all : 서버 데이터를 화면에 전부 그린다 ──
function render_order_all() {
    hideSooHPinfo();
    $('#firstLoadingDataDiv').hide();

    window.total_order_count = 0;
    window.showPriceTotal = 0;
    window.boxOn_showCnt = 0;

    // 로딩 이미지 숨기기
    $('#trloadingfd').hide();

    // 작업완료 안된것 출력하기
    show_DataList(0);

    // 구분선 그리기
    if (window.total_order_count > 0) {
        $('#tableListUp').append(`<tr style="background-color:#295C89; height:10px;opacity:0.5"><td colspan=21></td></tr>`);
    }
    // 작업완료된것 출력하기
    show_DataList(9);

    // 검색조건에 해당되는것만 보여주기
    apply_filter(false);
}

// ── get_order_line_html : 오더 한줄 HTML ──
function get_order_line_html(order_info, is_tr) {
    var trHeader = document.getElementById("ttablememoTd");
    var crt = trHeader.getBoundingClientRect();
    var mWW = parseInt(crt.width);
    var work_day = order_info.work_day;
    var work_time = order_info.work_time;
    var Tds = "";
    var pp = parseInt(order_info.car_price); if (isNaN(pp)) pp = 0
    var order_type = Util.int(order_info.order_type, -1);
    var car_uniqnum = Util.int(order_info.car_vnum, -1);
    var driver_uniqnum = Util.int(order_info.driver_vnum, -1);
    var order_status = Util.int(order_info.order_status, -1);
    var smode = order_info.smode; // 1:발주, 2:수주
    var this_ordernum = Util.int(order_info.onum);
    // 아래 회원 입력값(차량번호·이름·주소·거래처·비고)은 셀 본문과 '…' 속성에 그대로 들어간다 — 정의할 때 이스케이프한다
    var H = Util.escapeHtml;
    var worker_carplate = order_info.car_plate == null ? undefined : H(order_info.car_plate);
    if (ordershow_type == 1) car_uniqnum = driver_uniqnum;

    if (order_type == 91) {
        car_uniqnum = "?";
    }

    var order_type_str = order_status_aryadmin[order_status];
    if (order_status == 99) order_type_str = "<font color=red>배차취소</font>";
    var fieldNumber = H(getString(order_info.site_phone));
    if (fieldNumber.length < 3) fieldNumber = H(getString(order_info.client_phone));
    // 이름은 서버가 회원 테이블로 만든 표시값 — 소속자면 '소유자(소속자)' (App\Services\Order\OrderPartyNames)
    var order_onwer_name = H(getString(order_info.bal_display));
    var worker_name = H(getString(order_info.worker_display));
    var worker_phone = getString(order_info.driver_phone);
    if (worker_phone.length < 2) worker_phone = getString(order_info.owner_phone);
    worker_phone = String(worker_phone).replace(/[^0-9\-]/g, '');   // onclick 의 JS 문자열 인자로 들어간다

    var inoutexpense = Util.int(order_info.inoutexpense);

    var work_dayhour = order_info.car_workhour;
    var work_dayTpe = order_info.car_workdaytype;
    var dayHr;
    work_dayTpe == "일" ? dayHr = " 일" : dayHr = "시간";
    var work_dayhourShow = $j.F.Car.getWorkHourStr(order_info, false);
    if (order_info.is_return_job == '1') {
        work_dayhourShow = '회차';
    }

    if (work_dayTpe == "일" || work_dayTpe == "하루") { if (work_dayhour == 0) work_dayhour = 1 + "일"; }
    var work_addHr = Util.int(order_info.add_hour);
    if (work_addHr == 0) work_addHr = "-";

    var soo_got_payed_price = Util.int(order_info.soo_got_payed_price);
    var car_baseprice = Util.int(order_info.car_price);
    var soo_got_payed = Util.int(order_info.soo_got_payed);
    var soo_print_taxbill = Util.int(order_info.soo_print_taxbill);
    var soo_got_pay_carnum = Util.int(order_info.soo_got_pay_carnum);
    var card_pay_inputok = Util.int(order_info.card_pay_inputok);

    var bal_got_payed = Util.int(order_info.bal_got_payed);
    var bal_print_taxbill_to_bal = Util.int(order_info.bal_print_taxbill_to_bal);
    var bal_gave_to_dirver = Util.int(order_info.bal_gave_to_dirver);
    var bal_got_taxbill_from_soo = Util.int(order_info.bal_got_taxbill_from_soo);
    var car_price = Util.int(order_info.car_price);

    var Tr_lineset = "";// 수금된건 회색
    var Tr_colorSet = "";
    var Tr_linesetNo;
    if (soo_got_payed_price >= car_baseprice && soo_got_payed >= 1 && (soo_print_taxbill >= 1 || soo_print_taxbill == 9 || soo_print_taxbill == 2)) {
        if (Util.int(order_info.soo_print_taxbill_price) <= Util.int(order_info.car_price)) {
            Tr_lineset = "line_blur ok";
        } else {
            if (Util.int(order_info.soo_got_payed_price) >= Util.int(order_info.car_price)) {
                Tr_lineset = "line_blur ok";
            } else {
                Tr_lineset = "B";
            }
        }
    } else {
        if ((soo_print_taxbill == 5 || soo_print_taxbill == 4) && soo_got_pay_carnum > 0 && card_pay_inputok == 1) {
            Tr_lineset = "line_blur ok";
        }
    }

    // 발주시
    if (smode == 1) {
        var isHyunSoo = parseInt(order_info.pay_method);
        if (isNaN(isHyunSoo)) isHyunSoo = 1;
        var gavePrice = Util.int(order_info.bal_gave_to_dirver_price);
        if (order_info.pay_method == 2) Tr_colorSet = "background-color:#E6FFFF";
        if (order_info.pay_method == 5 && bal_got_payed > 0 && bal_print_taxbill_to_bal > 0) { Tr_lineset = "line_blur ok"; Tr_linesetNo = 4; }
        if (bal_print_taxbill_to_bal == 2) gavePrice = Util.int(order_info.bal_multi_moneyinTot);
        if (bal_gave_to_dirver == 1 && gavePrice >= car_baseprice && bal_got_taxbill_from_soo > 0 && bal_print_taxbill_to_bal > 0 && bal_got_payed == 1) {
            Tr_lineset = "line_blur ok";
        } else {
            if (bal_gave_to_dirver == 1 && gavePrice >= car_baseprice && bal_got_taxbill_from_soo > 0 && bal_print_taxbill_to_bal > 0) {
                if (Util.int(order_info.bal_got_payed_price) >= car_baseprice && (parseInt(order_info.bal_got_payed) == 1 || parseInt(order_info.soo_got_payed) == 1)) { Tr_lineset = "line_blur ok"; Tr_linesetNo = 6 };
            }
        }
    }

    if (order_status > 10 || (order_info.pay_method == 5 && smode == 1)) { Tr_lineset = "line_blur card"; Tr_linesetNo = 7 };
    if (order_status == 99) { Tr_lineset = "line_blur ok2"; Tr_linesetNo = 8 }
    if (car_price == 0 && Util.int(order_info.this_order_alldone) == 1) {
        Tr_lineset = "line_blur ok";
    }

    var Ax1 = show_payStatus(order_info); /// 결제유무
    var Ax2 = Soojoo_billinfo(order_info); // 계산서 유무
    var Ax3 = bill_print_statusGet(order_info); // 상대거래(유무)
    var sign_str = "";
    if (parseInt(order_info.pay_method) == 1) sign_str = "<font color=blue>(" + $j.F.Order.Biz.sign_due_str(order_info.sign_days) + ")</font>";

    var Ax1_Str = "미수", Ax2_Str = "발행", Ax3_Str = "-";

    var sooman = H(getString(order_info.soo_got_payed_sender));
    var balman = H(getString(order_info.bal_got_payed_sender));
    if (Ax1.indexOf("ordertype_sign_new2") > 0) {
        Ax1_Str = "싸인미수";
    } else if (Ax1.indexOf("payok_n") > 0) {
        smode == 2 ? Ax1_Str = "수금:" + sooman : Ax1_Str = "수금:" + balman;
    }

    if (Ax2.indexOf("tax_print_non") > 0) {
        Ax2_Str = "미발행";
    } else if (Ax2.indexOf("soo_getway3") > 0) {
        Ax2_Str = "카드";
    } else if (Ax2.indexOf("no_tax") > 0) {
        Ax2_Str = "무발행";
    } else {
        var pman = H(getString(order_info.soo_print_tax_coname));
        var gman = H(getString(order_info.bal_print_taxbill_to_bal_coname));
        if (smode == 2) {
            if (pman.length > 1) Ax2_Str = "발행:" + pman;
        } else {
            if (gman.length > 1) Ax2_Str = "발행:" + gman;
        }
    }

    if (Ax3.indexOf("cash_order2") > 0) Ax3_Str = "직수";
    if (Ax3.indexOf("pst_nopay_1") > 0 && Ax3.indexOf("pst_norecive_1") > 0) Ax3_Str = "지급&받음";
    if (Ax3.indexOf("pst_nopay_1") > 0 && Ax3.indexOf("no_tax") > 0) Ax3_Str = "지급&무발행";
    if (Ax3.indexOf("pst_nopay_1") > 0 && Ax3.indexOf("pst_norecive") > 0) Ax3_Str = "지급&안받음";
    if (Ax3.indexOf("cash_order2") > 0) Ax3_Str = "직수";
    if (Ax3.indexOf("cash_order2") > 0) Ax3_Str = "직수";
    if (Ax3.indexOf("pst_nopay") > 0) Ax3_Str = "미지급";
    if (Ax3.indexOf("pst_norecive") > 0) Ax3_Str = "안받음";
    if (Ax3.indexOf("pst_norecive") > 0 && Ax3.indexOf("pst_nopay") > 0) Ax3_Str = "미지급&안받음";
    if (Ax3.indexOf("pst_nopay") > 0 && Ax3.indexOf("pst_norecive_1") > 0) Ax3_Str = "미지급&받음";

    var contract_name = order_info.client_name || order_info.bal_print_taxbill_memo || order_info.payed_tome_co_name;
    contract_name = contract_name ? H(contract_name) : '';

    var trid = "tr_order_" + this_ordernum;
    var clickJob = "onclick='allSetIn_new(" + this_ordernum + " , 1)' realcall='show_Pop_BizForm' ";
    var clickJobC = "onclick='allSetIn_new(" + this_ordernum + " ,2)' realcall='show_Pop_BizForm'  ";
    if (Tr_lineset == "") Tr_lineset = "ongoing";
    var EaSet = "table-row";
    if (smode == 2) { clickJobC = ""; Ax3 = "" }

    var epp = parseInt(order_info.car_price);
    if (isNaN(epp)) epp = 0;
    window.showPriceTotal = parseInt(window.showPriceTotal + epp);

    var adr = H(order_info.site_address);
    var wdd = order_info.work_day.substr(5, 5);
    if (work_time == undefined) work_time = order_info.work_day + " 00:00:00";
    if (work_time.indexOf("0000-00") >= 0) {
        work_time = order_info.work_day + " " + Util.pad(order_info.work_start_h) + ":" + Util.pad(order_info.work_start_m) + ":00";
    }
    var arr = work_time.split("-");  // 2018,01,01 00:10:11
    var a1 = new Date(arr[0] + "/" + arr[1] + "/" + arr[2]);
    wdd = wdd.replace("-", ".") + " <font style='color:red;letter-spacing:-1px;mso-number-format:@;'>" + Util.pad(a1.getHours(), 2) + ":" + Util.pad(a1.getMinutes(), 2) + "</font>";
    var wdd_only = work_time.substr(5, 5) + " " + Util.pad(a1.getHours(), 2) + ":" + Util.pad(a1.getMinutes(), 2);
    var work_tExcel = order_info.work_day + " " + Util.pad(order_info.work_start_h, 2) + ":" + Util.pad(order_info.work_start_m, 2)
    var BtnC1 = " onclick=\"showClickedOrder(1," + this_ordernum + ",'" + order_info.work_day + "')\"";
    var BtnC2 = " onclick=\"showClickedOrder(2," + this_ordernum + ",'" + order_info.work_day + "')\"";

    var searchKeyData = this_ordernum + "|" + smode + "|" + order_info.car_price + "|" + contract_name;

    var chbox = "<input type='checkbox'  dtype='orderchbox' d_adrdate='" + wdd_only + "' d_adr='" + adr + "' d_plate='" + worker_carplate + "' data-attr='" + searchKeyData + "'  id='ordersel_" + this_ordernum + "' value='" + this_ordernum + "' style='width:20px;height:20px;vertical-align:top' >";
    if (window.onList.length < 250) window.onList.push(Util.int(this_ordernum));
    var eaMg = order_info.onemessage;
    if (eaMg == undefined || eaMg == null || eaMg == "null") eaMg = "";
    eaMg = H(eaMg);
    var eaMg_in = "<div style='width:" + mWW + "px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;'>" + eaMg + "</div>";
    var goMg = eaMg_in;
    if (mWW > 200) goMg = eaMg;
    var addr = H(order_info.site_address);
    var addr_show = addr;
    var mmma = show_carnum_plate(car_uniqnum, worker_carplate);
    const bonsaCode = Util.getParentSosokCode(order_info.order_sosok, 1);
    const bonsaName = bonsaList[bonsaCode];

    const feeRate = get_order_fee_rate(order_info);
    const carOption = H($j.F.Car.getCarRangeStr(order_info) + ' ' + $j.F.Car.getCarOptionStr(order_info));

    /* 체크박스 */ Tds += "<td  id='checkBodTds_" + this_ordernum + "' checked class='checkBodTd' cd1='" + order_type + "' cd2='" + H(order_info.direct_type) + "'>" + chbox + "</td>";
    /* 차넘버링 */ Tds += "<td  id='tdx1' data_val='" + car_uniqnum + "' car_uniqnum='" + order_info.car_vnum + "' driver_uniqnum='" + order_info.driver_vnum + "' " + BtnC1 + ">" + show_car_no(order_info) + "</td>";
    /* 차량번호 */ Tds += "<td  id='tdx2' data_val='" + worker_carplate + "' " + BtnC2 + " style='width:70px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; text-align:left'>" + mmma + "</td>"; //
    /* 작업날짜 */ Tds += "<td  id='tdx3' data_val='" + work_tExcel + "' style='font-weight:bolder' " + BtnC2 + " ds='" + work_time + "'>" + wdd + "</td>";
    /* 현장주소 */ Tds += "<td  id='tdx4' data_val='" + addr + "'  style='text-align:left' " + BtnC2 + ">" + addr_show + "</td>";
    /* 톤수 */ Tds += "<td  id='tdx19' style='text-align:left' " + BtnC2 + ">" + carOption + "</td>";
    /* 수수료율 */ Tds += "<td  id='tdx20' data_val='" + feeRate + "'  style='text-align:' " + BtnC2 + ">" + feeRate + "%</td>";
    /* 본사 */ Tds += "<td  id='tdx18' data_val='" + bonsaName + "' " + BtnC2 + " ds='" + bonsaName + "'>" + bonsaName + "</td>";
    /* 거래처 */ Tds += "<td  id='tdx5' data_val='" + contract_name + "'' " + BtnC2 + ">" + contract_name + "</td>";
    /* 현장번호 */ Tds += "<td  id='tdx6' data_val='" + fieldNumber + "'>" + fieldNumber + "</td>";
    /* 발주자명 */ Tds += "<td  id='tdx7' data_val='" + order_onwer_name + "'>" + order_onwer_name + "</td>";
    /* 수주자명 */ Tds += "<td  id='tdx8' data_val='" + worker_name + "' onclick=\"showOrderInfo(this , '" + worker_phone + "')\">" + worker_name + "</td>";
    /* 사용경비 */ Tds += "<td  id='tdx9' data_val='" + inoutexpense + "'>" + Util.formatNumber(inoutexpense) + "</td>";
    /* 작업상태 */ Tds += "<td  id='tdx10' data_val='" + order_type_str + "'>" + order_type_str + "</td>";
    /* 작업시간 */ Tds += "<td  id='tdx11' data_val='" + work_dayhourShow + "'>" + work_dayhourShow + "</td>";
    /* 추가시간 */ Tds += "<td  id='tdx12' data_val='" + work_addHr + "'>" + work_addHr + "</td>";
    /* 작업비용 */ Tds += "<td  id='tdx13' data_val='" + order_info.car_price + "'>" + Util.formatNumber(order_info.car_price) + "</td>";
    /* 결제유무 */ Tds += "<td  id='tdx14' data_val='" + Ax1_Str + "' style='text-align:left' " + clickJob + ">&nbsp;" + Ax1 + sign_str + "</td>";
    /* 계산유무 */ Tds += "<td  id='tdx15' data_val='" + Ax2_Str + "' style='text-align:left' " + clickJob + ">&nbsp;" + Ax2 + "</td>";
    /* 상대거래 */ Tds += "<td  id='tdx16' data_val='" + Ax3_Str + "' style='text-align:left' " + clickJobC + ">&nbsp;" + Ax3 + "</td>";
    /* 비고비고 */ Tds += "<td  id='showmessageeaTd_" + this_ordernum + "' data_val='" + eaMg + "' style='text-align:left'>" + goMg + "</td>";

    var row = {
        'id': trid,
        'class': get_order_payed_class(order_info),// 수금된것 회색배경, 안그런것 흰색배경
        'tds': Tds
    };
    let tpl = '';
    if (is_tr) {
        tpl = `<tr class="{class}" id="{id}">{tds}</tr>`;
    } else {
        tpl = `{tds}`;
    }

    return Util.render_template(tpl, row);
}

// ── show_payStatus : 결제 유무 ──
function show_payStatus(order_info) {
    var PayStatusStrRet = "미수";
    let smode = order_info.smode;
    if (smode == 2) {
        var howtopay_done = Util.int(order_info.pay_result); //
        var work_payment = Util.int(order_info.is_paid);
        var card_pay_inputok = Util.int(order_info.card_pay_inputok);
        var soo_got_payed = Util.int(order_info.soo_got_payed);
        var soo_got_payed_price = Util.int(order_info.soo_got_payed_price);
        var soo_print_taxbill = Util.int(order_info.soo_print_taxbill);
        var soo_print_taxbill_price = Util.int(order_info.soo_print_taxbill_price);
        var car_baseprice = Util.int(order_info.car_price);
        if (soo_print_taxbill > 0) car_baseprice = Util.int(car_baseprice + (car_baseprice * 0.1));
        if (Util.int(order_info.soo_print_taxbill) == 6) car_baseprice = Util.int(order_info.car_price);
        var ThisInfoStrA = "smode='" + smode + "' work_payment='" + work_payment + "  soo_got_payed='" + soo_got_payed + "' soo_got_payed_price='" + soo_got_payed_price + "' car_baseprice='" + car_baseprice + "' ";
        if (work_payment == 0 && soo_got_payed == 0) {
            if (Util.int(order_info.pay_method) == 1) {
                PayStatusStrRet = "싸인수금";
                howtopay_done = "<img src='/img/ordertype_sign_new2.png' data-od='1' style='margin:0px;padding:0px'>";
            } else {
                PayStatusStrRet = "싸인미수";
                howtopay_done = "<img src='/img/cash_recive_no_new.png' data-od='2' style='margin:0px;padding:0px'" + ThisInfoStrA + " txif=1>";
            }
        } else {
            if ((soo_got_payed == 1 && soo_got_payed_price > 0) || order_info.car_price == "0" || order_info.pay_method == 5) {
                var soo_got_payed_way = order_info.soo_got_payed_way;
                if (Util.int(order_info.soo_got_payed_taxprice) > car_baseprice) car_baseprice = Util.int(order_info.soo_got_payed_taxprice);
                if (order_info.car_price == "0") car_baseprice = 0;///part_got
                var stimg = "<img src='/img/cash_recive_no_new.png' data-od='3' style='margin:0px;padding:0px' " + ThisInfoStrA + " txif=2>";
                if (soo_got_payed_way == "입금" || Util.int(order_info.car_price) == 0) stimg = "<img src='/img/payok_n.png' data-od='4' style='margin:0px;padding:0px' " + ThisInfoStrA + " >";
                if (soo_got_payed_way == "현금" || soo_got_payed_way == "직수") stimg = "<img src='/img/payok_n.png' data-od='5' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                var chPP = Util.int(order_info.soo_got_payed_price);
                if (Util.int(order_info.soo_print_taxbill) == 6) chPP = Util.int(order_info.soo_multi_printTot);
                if (chPP < car_baseprice) {
                    if (Util.int(soo_print_taxbill) == 9) {
                        if (Util.int(order_info.car_baseprice) > Util.int(order_info.soo_got_payed_price)) {
                            PayStatusStrRet = "직수수금";
                            var stimg = "<img src='/img/payok_n.png' data-od='6' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                        } else {

                            var stimg = "<img src='/img/payok_n.png' data-od='7' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                        }
                    } else {
                        var stimg = "<img src='/img/cash_recive_no_new.png' data-od='8' style='margin:0px;padding:0px' " + ThisInfoStrA + " txif=3 " + ThisInfoStrA + ">";
                    }

                } else {
                    var stimg = "<img src='/img/payok_n.png' data-od='7' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                }

                if (soo_got_payed_way == "카드") {
                    if (card_pay_inputok == 1) {
                        var stimg = "<img src='/img/payok_n.png' data-od='9' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                    } else {
                        var stimg = "<img src='/img/cash_recive_no_new.png' data-od='10'  style='margin:0px;padding:0px' " + ThisInfoStrA + " txif=4 " + ThisInfoStrA + ">";
                    }
                }

                howtopay_done = stimg; //<img src='/img/cash_recive_ok.png' style='margin:0px;padding:0px'>
                var soo_got_payed_date = getString(order_info.soo_got_payed_date);

                var soo_got_payed_sender = getString(order_info.soo_got_payed_sender);
                var soo_got_payed_way = getString(order_info.soo_got_payed_way);
                if (soo_got_payed_date.length == 10) {
                    var ss = soo_got_payed_date.substr(5, 10);
                    ss = ss.replace("-", "/");
                    ss += "";
                    howtopay_done += "<font style='color:#0080FF;font-weight:bold'>" + ss + "</font> ";
                }
                if (soo_got_payed_sender.length > 0) howtopay_done += soo_got_payed_sender.replace("카드", "") + " ";
                if (soo_got_payed_price > 0) {//
                    var this_order_alldone = Util.int(order_info.this_order_alldone);
                    if (soo_got_payed_price < car_baseprice && this_order_alldone != 1) {
                        var bal_print_taxbill_to_bal = Util.int(order_info.bal_print_taxbill_to_bal);
                        var soo_print_taxbill = Util.int(order_info.soo_print_taxbill);
                        if ((bal_print_taxbill_to_bal == 9 || soo_print_taxbill == 9)) {
                            howtopay_done += Util.formatNumber(soo_got_payed_price);
                        } else {
                            var stt = " style='background-color:red;color:white;padding:5px' ";
                            var DoneBtn = " <input type='button' value='완료처리/ " + this_order_alldone + "' " + stt + " onclick=\"order_clearSet(" + order_info.order_num + ",event," + smode + ",0,1," + order_info.taxnum + ")\"></font>";
                            howtopay_done += "<font color=red>" + Util.formatNumber(Util.int(car_baseprice - soo_got_payed_price)) + DoneBtn;
                        }
                    } else {
                        howtopay_done += Util.formatNumber(soo_got_payed_price) + "";
                    }
                }
            } else {
                if (Util.int(order_info.pay_method) == 1) {
                    PayStatusStrRet = "싸인수금";
                    howtopay_done = "<img src='/img/ordertype_sign_new2.png' data-od='1' style='margin:0px;padding:0px'>";
                } else {
                    PayStatusStrRet = "싸인미수";
                    howtopay_done = "<img src='/img/cash_recive_no_new.png' data-od='2' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
                }
            }
        }
        if (Util.int(order_info.order_status) == 99) howtopay_done = "-";
    } else {
        var bal_print_taxbill_to_bal = Util.int(order_info.bal_print_taxbill_to_bal);
        var bal_gave_to_dirver = Util.int(order_info.bal_gave_to_dirver);
        var bal_got_taxbill_from_soo = Util.int(order_info.bal_got_taxbill_from_soo);
        var bal_got_payed_way = getString(order_info.bal_got_payed_way);
        var car_baseprice = Util.int(order_info.car_baseprice);
        if (Util.int(order_info.bal_gave_to_dirver_texprice) > car_baseprice) car_baseprice = Util.int(order_info.bal_gave_to_dirver_texprice);
        var bal_got_payed_date = getString(order_info.bal_got_payed_date); //bal_got_payed_date
        var soo_got_payed_price = Util.int(order_info.bal_got_payed_price);
        var soo_got_payed_sender = getString(order_info.bal_got_payed_sender);
        var howtopay_done = "";
        if (bal_got_payed_date.length == 10) {
            var ss = bal_got_payed_date.substr(5, 10);
            ss = ss.replace("-", "/");
            ss += " ";
            howtopay_done += "<font style='color:#0080FF;font-weight:bold'>" + ss + "</font> ";
        }
        if (soo_got_payed_sender.length > 0) howtopay_done += soo_got_payed_sender + " ";
        var stimg_on = "";
        var ThisInfoStrA = "smode='" + smode + "' bal_got_payed='" + order_info.bal_got_payed + "  soo_got_payed_price='" + soo_got_payed_price + "' ";

        if (soo_got_payed_price > 0 && parseInt(order_info.bal_got_payed) == 1) {
            howtopay_done += Util.formatNumber(soo_got_payed_price);
            stimg_on = "<img src='/img/payok_n.png' data-od='14' style='margin:0px;padding:0px'" + ThisInfoStrA + ">";;
        }
        stimg = stimg_on;
        if (Util.int(order_info.bal_got_payed) > 0) {
            if (bal_got_payed_way == "입금") stimg = "<img src='/img/payok_n.png' data-od='15' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";;
            if (bal_got_payed_way == "현금" || bal_got_payed_way == "직수") stimg = "<img src='/img/payok_n.png' data-od='16'  style='margin:0px;padding:0px' " + ThisInfoStrA + ">";;
        }
        if (Util.int(order_info.bal_got_payed_price) > 0 && Util.int(order_info.bal_got_payed) > 0) stimg = "<img src='/img/payok_n.png' data-od='16_1'  style='margin:0px;padding:0px' " + ThisInfoStrA + ">";;

        if (bal_got_payed_way == "카드") stimg = "<img src='/img/soo_getway3.png' data-od='17' style='margin:0px;padding:0px'>";

        if (stimg.length < 2) {
            if (order_info.pay_method == 1) {
                stimg = "<img src='/img/ordertype_sign_new2.png' data-od='29' style='margin:0px;padding:0px'>";
            } else {
                stimg = "<img src='/img/cash_recive_no_new.png' data-od='29' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";
            }
        }
        howtopay_done = stimg + howtopay_done;
    }
    if (Util.int(order_info.order_status) == 99) howtopay_done = "-";
    return howtopay_done;
}

// ── Soojoo_billinfo : 계산서 유무 ──
function Soojoo_billinfo(order_info) {
    let smode = order_info.smode;
    var car_baseprice = Util.int(order_info.car_baseprice); //soo_got_payed   bill_print_stok_gray_mul
    var soo_print_taxbill = Util.int(order_info.soo_print_taxbill);
    var work_payment = Util.int(order_info.is_paid);
    var soo_got_payed = Util.int(order_info.soo_got_payed);
    var soo_got_payed_price = Util.int(order_info.soo_got_payed_price);
    var bal_print_taxbill_to_bal = getString(order_info.bal_print_taxbill_to_bal);
    if (!isNaN(parseInt(bal_print_taxbill_to_bal))) bal_print_taxbill_to_bal = parseInt(bal_print_taxbill_to_bal);
    var ThisInfoStrA = "ty='" + soo_print_taxbill + "' smode='" + smode + "' work_payment='" + work_payment + "  soo_got_payed='" + soo_got_payed + "' soo_got_payed_price='" + soo_got_payed_price + "' car_baseprice='" + car_baseprice + "' bal_print_taxbill_to_bal='" + bal_print_taxbill_to_bal + "' ";

    if (smode == 2) {
        var soo_print_taxbill_printdate = getString(order_info.soo_print_taxbill_printdate);
        var soo_print_tax_coname = getString(order_info.soo_print_tax_coname);
        var soo_print_taxbill_price = Util.int(order_info.soo_print_taxbill_price);
        if (soo_print_taxbill == 0) {
            ret = "<img src='/img//tax_print_non.png' style='margin:0px;padding:0px' ac='FA' " + ThisInfoStrA + ">";
        } else if (soo_print_taxbill == 9 || soo_print_taxbill == 6) {
            ret = "<img src='/img/no_tax.png' style='margin:0px;padding:0px' ac='FB' " + ThisInfoStrA + ">";
        } else {
            var soo_got_payed_way = getString(order_info.soo_got_payed_way);
            var card_pay_inputok = getString(order_info.card_pay_inputok);
            if (order_info.pay_method == 5) { //카드
                ret = "<img src='/img//soo_getway3.png' style='margin:0px;padding:0px' data_xd='2' " + ThisInfoStrA + ">";
                if (Util.int(order_info.soo_got_pay_carnum) > 0) soo_print_taxbill_price = Util.int(order_info.soo_got_card_tot);
            } else {
                ret = "<img src='/img//bill_print_stok_gray.png' style='margin:0px;padding:0px' ac='Aa' " + ThisInfoStrA + ">";
                if (soo_print_taxbill == 2 || soo_print_taxbill == "2") {
                    ret = "<img src='/img/bill_print_stok_gray_mul.png' style='margin:0px;padding:0px'  ty='" + soo_print_taxbill + "' smode='" + smode + "' ac='Ab' " + ThisInfoStrA + ">";
                    if (order_info.ordernum == "86662") console.log("CCCC");
                } else {
                    if (order_info.ordernum == "86662") console.log("DDDD");
                }
            }
            if (soo_print_taxbill_printdate.length == 10) {
                var ss = soo_print_taxbill_printdate.substr(5, 10);
                ss = ss.replace("-", "/");
                ss += " ";
                ret += "<font style='color:#0080FF;font-weight:bold'>" + ss + "</font>";
            }
            if (soo_print_taxbill == 2) soo_print_taxbill_price = getString(order_info.soo_multi_printTot);
            if (soo_print_tax_coname.length > 0) ret += soo_print_tax_coname + "";
            if (soo_print_taxbill_price > 0) {
                if (order_info.pay_method == 5) {
                    var PP_soo_got_card_tot = Util.int(order_info.soo_got_card_tot);
                    var tax_after = Util.int(car_baseprice + (car_baseprice * 0.10));
                    var p2 = Util.int(tax_after * 0.029);
                    var p3 = Util.int(p2 * 0.1);
                    var Plast = Util.int(PP_soo_got_card_tot - p2);
                    ret += " " + Util.formatNumber(Plast);
                } else {
                    ret += " " + Util.formatNumber(soo_print_taxbill_price);
                }
            }
            if (soo_got_payed_way == "카드") {
                //if(card_pay_inputok == 1 ) { ret+= "<img src='/img/bankInputok.png' style='margin:0px;padding:0px'>";}else{ ret+= "";}
            }
            if (Util.int(order_info.car_price) == 0 && soo_print_taxbill == 0) {
                ret = "<img src='/img/no_taxbill.png' style='margin:0px;padding:0px;height:20px' " + ThisInfoStrA + ">";
            }
        }
    } else {
        if (bal_print_taxbill_to_bal == 9) {
            ret = "<img src='/img/no_tax.png' style='margin:0px;padding:0px' " + ThisInfoStrA + ">";

        } else if (bal_print_taxbill_to_bal > 0) {
            var ret = "<img src='/img/bill_print_stok_gray.png' style='margin:0px;padding:0px'  ty='" + bal_print_taxbill_to_bal + "' smode='" + smode + "' ac='Ba' " + ThisInfoStrA + ">";
            if (bal_print_taxbill_to_bal == 2 || bal_print_taxbill_to_bal == "2") {
                ret = "<img src='/img/bill_print_stok_gray_mul.png' style='margin:0px;padding:0px'  ty='" + bal_print_taxbill_to_bal + "' hs2='1' smode='" + smode + "' ac='Bb' " + ThisInfoStrA + ">";

            }
            var bal_print_taxbill_to_bal_date = getString(order_info.bal_print_taxbill_to_bal_date);
            var bal_print_taxbill_to_bal_coname = getString(order_info.bal_print_taxbill_to_bal_coname);
            var bal_print_taxbill_price = Util.int(order_info.bal_print_taxbill_price);
            if (soo_print_taxbill == 2) bal_print_taxbill_price = Util.int(order_info.bal_multi_printTot);
            if (bal_print_taxbill_to_bal_date.length == 10) {
                var ss = bal_print_taxbill_to_bal_date.substr(5, 10);
                ss = ss.replace("-", "/");
                ss += " ";
                ret += "<font style='color:#0080FF;font-weight:bold'>" + ss + "</font> ";
            }
            if (bal_print_taxbill_to_bal_coname.length > 0) ret += bal_print_taxbill_to_bal_coname + "";
            if (bal_print_taxbill_price > 0) ret += Util.formatNumber(bal_print_taxbill_price);
        } else {
            ret = "<img src='/img/tax_print_non.png' style='margin:0px;padding:0px' " + ThisInfoStrA + ">"; //ret= "*거래처 미발행";
        }
        if (Util.int(order_info.car_price) == 0 && bal_print_taxbill_to_bal == 0) {
            ret = "<img src='/img/no_taxbill.png' style='margin:0px;padding:0px;height:20px' " + ThisInfoStrA + ">";
        }
    }
    if (Util.int(order_info.order_status) == 99) ret = "-";
    return ret;
}

// ── bill_print_statusGet : 상대거래 유무 ──
function bill_print_statusGet(order_info) {
    let smode = order_info.smode;
    if (smode == 1) {
        var bal_print_taxbill_to_bal = Util.int(order_info.bal_print_taxbill_to_bal);
        var bal_gave_to_dirver = Util.int(order_info.bal_gave_to_dirver);
        var bal_got_taxbill_from_soo = Util.int(order_info.bal_got_taxbill_from_soo);
        var car_baseprice = Util.int(order_info.car_baseprice);
        if (Util.int(order_info.bal_got_taxbill_from_price) > car_baseprice) car_baseprice = Util.int(order_info.bal_got_taxbill_from_price);
        var bal_gave_to_dirver_price = Util.int(order_info.bal_gave_to_dirver_price);
        var bal_gave_to_diver_date = getString(order_info.bal_gave_to_diver_date);
        var bal_got_taxbill_from_date = getString(order_info.bal_got_taxbill_from_date);

        if (order_info.pay_method == 2) { ///////// 1 : 싸인 , 2 :직수
            var ret = "<img src='/img/cash_order2.png' style='margin:0px;padding:0px'>";
        } else {
            var ret = "";
            var Sign_str = "";
            if (order_info.pay_method == 5) {
                return "<img src='/img/soo_getway3_card.png' style='margin:0px;padding:0px' data_xd='1'>";
            }
            if (bal_gave_to_dirver == 1) {
                ret += "<img src='/img/pst_nopay_1.png' style='margin:0px;padding:0px'>";
                ret += "<font style='vertical-align:top;line-height:30px'>" + bal_gave_to_diver_date.substr(5, 10) + "</font>";
            } else {
                ret += "<img src='/img/pst_nopay.png' style='margin:0px;padding:0px'>";
            }
            if (bal_got_taxbill_from_soo == 1 || bal_got_taxbill_from_soo == 9) {
                if (bal_got_taxbill_from_soo == 9) {
                    ret += "<img src='/img/no_tax.png' style='margin:0px;padding:0px'>";
                } else {
                    ret += "<img src='/img/pst_norecive_1.png' style='margin:0px;padding:0px'>";
                }
                ret += "<font style='vertical-align:top;line-height:30px'>" + bal_got_taxbill_from_date.substr(5, 10) + "</font>";
            } else {
                ret += "<img src='/img/pst_norecive.png' style='margin:0px;padding:0px'>";
            }
        }
    } else {
        ret = "-";
    }
    if (Util.int(order_info.order_status) == 99) ret = "-";
    return ret;
}

// ── show_DataList : 오더 목록 출력 (atttn 0=미완료 9=완료) ──
function show_DataList(atttn) {
    var tds = "";
    orderTax.list.forEach((order_info, idx) => {
        if (atttn == 0 && order_info.order_status > 7) return;
        if (atttn == 9 && order_info.order_status <= 7) return;
        tds += get_order_line_html(order_info, 1);
        window.total_order_count++;
    });
    $('#tableListUp').append(tds);
}

// ── showOrderInfo / hideSooHPinfo : 수주자명 클릭 팝업 ──
function showOrderInfo(tar, num) {
    var rt = tar.getBoundingClientRect();
    var ax = rt.left;
    var ay = parseInt(rt.bottom + doc_Scroll);
    hideSooHPinfo();
    var TR = document.createElement('DIV');
    TR.setAttribute("style", "width:200px; background-color:#FFFFFF; color:#000000;text-align:center; position:absolute; top:" + ay + "px; left:" + ax + "px; border:1px solid #808080;  -webkit-border-radius: 10px;  -moz-border-radius: 10px;  border-radius: 10px;padding:10px;box-shadow: gray 2px 2px 2px 2px;");
    TR.setAttribute("id", "easeldirverPhDiv");
    TR.setAttribute("onclick", "hideSooHPinfo()");
    TR.innerHTML = num;
    document.body.appendChild(TR);
}
function hideSooHPinfo() {
    var obj = document.getElementById("easeldirverPhDiv");
    if (obj) {
        document.body.removeChild(obj);
    }
}

// ── show_car_no : 가상번호 표시 ──
function show_car_no(order_info) {
    const smode = order_info.smode;
    let vnum = order_info.driver_vnum;
    const order_status = order_info.order_status;
    var cc = "red";
    var fontW = "bolder";

    vnum = parseInt(vnum);
    if (isNaN(vnum)) vnum = 0;
    if (smode == 1 && order_info.order_type != 92) vnum = -1;
    if (vnum < 0) { vnum = 0; cc = "#000000"; }
    if (order_status == 99) { cc = "#FFFFFF"; fontW = "normal"; }
    var val = "<font style='font-weight:" + fontW + ";color:" + cc + " ;font-size:18px'>" + mkList[vnum] + "</font>";
    return val;
}

function getString(str) {
    if (str == null || str == undefined) str = "";
    return str;
}

// 표기용 수수료율 — 수주 전엔 발주수수료, 배차완료(6) 이후엔 수주수수료를 보여준다.
function get_order_fee_rate(order_info) {
    if (order_info['is_fee'] != 1) return 0;
    let r = order_info['bal_fee_rate'];
    if (r == 0) r = 10;
    if (order_info['order_status'] >= 6 && order_info['order_status'] != 99) r = order_info['soo_fee_rate'];
    return r || 0;
}

function show_carnum_plate(car_unum, worker_carplate) {
    var cc = "red";
    if (car_unum < 0) {
        car_unum = 0;
        cc = "#000000";
        return "-";
    }
    if (worker_carplate == undefined) worker_carplate = "";
    if (worker_carplate == "") worker_carplate = "<font style='color:#FFFFFF'>0000</font>";
    return worker_carplate;
}

// ── get_order_payed_type / get_order_payed_class : 수금완료 여부 판정 + css class ──
function get_order_payed_type(order_info) {
    let smode = Util.int(order_info.smode);// 1:발주, 2:수주
    var soo_got_payed_price = Util.int(order_info.soo_got_payed_price);// 수금금액
    var soo_print_taxbill = Util.int(order_info.soo_print_taxbill);
    var car_baseprice = Util.int(order_info.car_price);// 장비대금
    var soo_got_payed = Util.int(order_info.soo_got_payed); // 결제받았는지 여부
    var soo_got_pay_carnum = Util.int(order_info.soo_got_pay_carnum);
    var card_pay_inputok = Util.int(order_info.card_pay_inputok);
    var bal_gave_to_dirver = Util.int(order_info.bal_gave_to_dirver);
    var bal_got_taxbill_from_soo = Util.int(order_info.bal_got_taxbill_from_soo);
    var bal_print_taxbill_to_bal = Util.int(order_info.bal_print_taxbill_to_bal);
    var bal_got_payed = Util.int(order_info.bal_got_payed);
    let howtopay = Util.int(order_info.pay_method);// 결제책임
    var order_status = Util.int(order_info.order_status, -1);
    var car_price = Util.int(order_info.car_price);
    let ret = 0;

    // 수주인경우
    if (smode == 2) {
        if (soo_got_payed_price >= car_baseprice && soo_got_payed >= 1 && (soo_print_taxbill >= 1)) {
            if (Util.int(order_info.soo_print_taxbill_price) <= Util.int(order_info.car_price)) {
                ret = 1;
            } else {
                if (Util.int(order_info.soo_got_payed_price) >= Util.int(order_info.car_price)) {
                    ret = 1;
                }
            }
        } else {
            if (([4, 5].includes(soo_print_taxbill)) && soo_got_pay_carnum > 0 && card_pay_inputok == 1) {
                ret = 1;
            }
        }
    }
    // 발주인 경우
    else if (smode == 1) {
        var gavePrice = Util.int(order_info.bal_gave_to_dirver_price);
        switch (howtopay) {
            case 1:// 싸인
                if (bal_print_taxbill_to_bal == 2) gavePrice = Util.int(order_info.bal_multi_moneyinTot);

                if (bal_gave_to_dirver == 1 && gavePrice >= car_baseprice && bal_got_taxbill_from_soo > 0 && bal_print_taxbill_to_bal > 0 && bal_got_payed == 1) {
                    ret = 1;
                } else {
                    if (bal_gave_to_dirver == 1 && gavePrice >= car_baseprice && bal_got_taxbill_from_soo > 0 && bal_print_taxbill_to_bal > 0) {
                        if (Util.int(order_info.bal_got_payed_price) >= car_baseprice && (parseInt(order_info.bal_got_payed) == 1 || parseInt(order_info.soo_got_payed) == 1)) {
                            ret = 1;
                        }
                    }
                }
                break;
            case 2:// 직수
                ret = -1;
                break;
            case 3:// 카드
            case 5:// 카드
                ret = 1;
                break;
        }

    }

    if (order_status == 99) {
        ret = 99;
    }
    if (car_price == 0 && Util.int(order_info.this_order_alldone) == 1) {
        ret = 1;
    }
    return ret;
}

function get_order_payed_class(order_info) {
    let ret = get_order_payed_type(order_info);
    let clss = '';
    switch (ret) {
        case -1: clss = 'ongoing cyan'; break; // 직수
        case 0: clss = 'ongoing'; break; // 미수
        case 1: clss = 'line_blur ok'; break; // 수금완료
        case 99: clss = 'line_blur ok2'; break; // 취소
    }
    return clss;
}

/**
 * 레거시 전역 호출처(SearchFilter/ExpensePanel/list.js 잔류/생성 onclick)에 window 브리지.
 */
export default class ListRender {
    render_order_all = render_order_all;
    get_orders = get_orders;
    get_order_payed_type = get_order_payed_type;
    showOrderInfo = showOrderInfo;
    hideSooHPinfo = hideSooHPinfo;
}
